import axios from "axios";

// Utility function to get the user's latitude, longitude, state, and city
export const getUserLocation = async () => {
  return new Promise((resolve, reject) => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          try {
            const geocodingApiKey = "AIzaSyAr1Y049iJp1ZFKHYRnqa9AireOVkeBLpQ";

            const geocodingUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${geocodingApiKey}`;

            const response = await axios.get(geocodingUrl);

            if (response.data.results.length > 0) {
              // Extract address components
              const addressComponents =
                response.data.results[0].address_components;

              // Find state
              const stateComponent = addressComponents.find((component) =>
                component.types.includes("administrative_area_level_1")
              );
              const state = stateComponent ? stateComponent.long_name : null;

              // Find city
              const cityComponent = addressComponents.find(
                (component) =>
                  component.types.includes("locality") ||
                  component.types.includes("administrative_area_level_2")
              );
              const city = cityComponent ? cityComponent.long_name : null;

              // Resolve with latitude, longitude, state, and city
              resolve({
                latitude,
                longitude,
                state,
                city,
              });
            } else {
              reject(
                new Error("Unable to determine location from coordinates.")
              );
            }
          } catch (error) {
            console.error("Geocoding API error:", error.message);
            reject(
              new Error("Error fetching location data from Geocoding API.")
            );
          }
        },
        (err) => {
          reject(
            new Error("Unable to fetch location. Please check your settings.")
          );
        }
      );
    } else {
      reject(new Error("Geolocation is not supported by your browser."));
    }
  });
};

export const Logo = ({ width = 40, height = 40, ...props }) => {
  return (
    <img
      src="/appLogo.jpeg" // Path to the logo in the public folder
      alt="Logo"
      width={width}
      height={height}
      {...props} // Pass additional props if needed
    />
  );
};

export default Logo;
